import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import OutputAreasMap, { pointerInfoEmpty } from "components/visuals/maps/OutputAreasMap";
import useColourPalette from "components/visuals/useColourPalette";

import MarketCatSpendPerHeadMapPopup from "./MarketCatSpendPerHeadMapPopup";
import StoreMarker from "./StoreMarker";

import { selectMapboxConfiguration } from "modules/siteConfiguration/siteConfigurationSlice";
import { selectors } from "modules/customer/insights/portfolio/areaHealth/marketCategorySpend";

const MarketCatSpendPerHeadMap = () => {
    const colourPalette = useColourPalette();
    const mapboxConfiguration = useSelector(selectMapboxConfiguration);
    const marketCatSpendPerHeadMap = useSelector(state => selectors.marketCatSpendPerHeadMap(state));
    const { loading, error, mapCenter, spendPerHead, comparatorSpendPerHead } = marketCatSpendPerHeadMap;
    const outputAreas = spendPerHead.map(item => ({
        code: item.outputAreaCode,
        colourGroup: item.percentile
    }));
    const [initialViewport, setInitialViewport] = React.useState({
        latitude: mapCenter.latitude,
        longitude: mapCenter.longitude,
        zoom: 13.5
    });
    const [hoverInfo, setHoverInfo] = React.useState(pointerInfoEmpty);
    const [clickInfo, setClickInfo] = React.useState(pointerInfoEmpty);

    React.useEffect(() => {
        setInitialViewport(current => {
            return {
                ...current,
                latitude: mapCenter.latitude,
                longitude: mapCenter.longitude
            };
        });
    }, [mapCenter]);

    return (
        <Box data-cy="market-cat-spend-per-head-map">
            <OutputAreasMap
                loading={loading}
                error={error}
                mapboxAccessToken={mapboxConfiguration.accessToken}
                mapboxBaseMapStyle={mapboxConfiguration.baseMapStyle}
                mapboxOutputAreasTilesetId={mapboxConfiguration.outputAreasTilesetId}
                mapboxOutputAreasTilesetUrl={mapboxConfiguration.outputAreasTilesetUrl}
                initialViewport={initialViewport}
                addGeocoder={false}
                outputAreas={outputAreas}
                colours={colourPalette.heatmap}
                onHover={setHoverInfo}
                onClick={setClickInfo}
                downloadData={spendPerHead}
            >
                <MarketCatSpendPerHeadMapPopup
                    spendPerHead={spendPerHead}
                    comparatorSpendPerHead={comparatorSpendPerHead}
                    hoverInfo={hoverInfo}
                    clickInfo={clickInfo}
                />
                <StoreMarker mapCenter={mapCenter}/>
            </OutputAreasMap>
        </Box>
    );
};

export default MarketCatSpendPerHeadMap;
